import React from 'react';
import { Carousel } from '../../../../../components/Carousel';
import styles from './PlusProductSummary.module.scss';
import { Image as FiImage } from '../../../../../components/Image';
import { showNanoVariant } from '../../../../../components/NanoBanner/NanoBanner';
import { getFiGrowthBook } from '../../../../../lib/growthbook';

export const PhoneProductCarousel = () => {
  const enabledPhoneProductCarousel = getFiGrowthBook().getFeatureValue<boolean>('ecom-phone-product-carousel', false);

  const hideMobileAppSection = showNanoVariant();

  if (hideMobileAppSection) {
    return null;
  }

  if (!enabledPhoneProductCarousel) {
    return null;
  }

  return (
    <>
      <Carousel className={styles.mobileAppCarousel} wrapAround={true} prevNextButtons={true}>
        <div className={styles.mobileAppImage}>
          <FiImage
            image={{
              type: 'image',
              url: '/product_images/smart-collar-v3b/app-ui-homescreen-1.png',
              descriptors: ['1000w'],
            }}
            loading="eager"
          />
        </div>
        <div className={styles.mobileAppImage}>
          <FiImage
            image={{
              type: 'image',
              url: '/product_images/smart-collar-v3b/app-ui-homescreen-2.png',
              descriptors: ['1000w'],
            }}
            loading="eager"
          />
        </div>
        <div className={styles.mobileAppImage}>
          <FiImage
            image={{
              type: 'image',
              url: '/product_images/smart-collar-v3b/app-ui-homescreen-3.png',
              descriptors: ['1000w'],
            }}
            loading="eager"
          />
        </div>
      </Carousel>
    </>
  );
};
